import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { WarehouseRecord } from '@/types/warehouse';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';
import type { WarehouseCreate } from './createWarehouse';

/** Plain JSON PATCH merges the stored record, including partial address updates. */
export type WarehousePatch = Partial<Omit<WarehouseCreate, 'address'>> & { address?: Partial<WarehouseCreate['address']> };

export const patchWarehouse = async (
  scope: RequestScope,
  { id, data }: { id: number; data: WarehousePatch },
  options: WriteRequestOptions
): Promise<EndpointResponse<WarehouseRecord>> => {
  try {
    const response = await scopedApi(scope).patch<EndpointResponse<WarehouseRecord>>(`warehouse/${id}`, data, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
